import { Section, Eyebrow, Heading } from './home-ui';
import { scrollToId } from './home-ui';

export default function WhatWeFix({ data }) {
    if (!data) return null;
    const { eyebrow, titleLine1, titleLine2, paragraph, cards = [] } = data;

    return (
        <Section id="help" bg="white">
            <div className="max-w-2xl">
                {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
                <Heading line1={titleLine1} line2={titleLine2} className="mt-4" />
                {paragraph && <p className="mt-4 text-lg text-ink-muted">{paragraph}</p>}
            </div>

            <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
                {cards.map((c) => (
                    <div key={c.slug || c.title}
                        className="group rounded-card border border-surface-line bg-white p-6 transition hover:border-brand hover:shadow-[0_10px_30px_rgba(11,34,101,0.09)]">
                        <div className="flex h-12 w-12 items-center justify-center rounded-field bg-brand-soft text-2xl">{c.icon}</div>
                        <h3 className="mt-5 font-display text-xl font-bold text-navy">{c.title}</h3>
                        <p className="mt-2 text-ink-muted">{c.text}</p>
                        {c.link && (
                            <a href={c.link}
                                onClick={(e) => { if (c.link.startsWith('#')) { e.preventDefault(); scrollToId(c.link.slice(1)); } }}
                                className="mt-4 inline-flex items-center gap-1 font-display font-semibold text-brand">
                                Learn more <span className="transition group-hover:translate-x-0.5">→</span>
                            </a>
                        )}
                    </div>
                ))}
            </div>
        </Section>
    );
}
